const setJsonProxy = (originDatas) => {
  return JSON.parse(JSON.stringify(originDatas))
}

export default setJsonProxy
